import { z } from "zod";
import { atom } from "jotai";

import { JotaiTool } from "../../index";
import { BuildItButton } from "./BuildItButton";

/**
 * Tool parameters for showing a Build it button in draft mode
 */
export const BuildItButtonParamsSchema = z.object({});

export type BuildItButtonResult = {
  success: boolean;
  message: string;
};

/**
 * Build it button tool for draft mode in Canvas AI toolkit
 * Shows a purple "Build it" button that executes ZSL and transitions to build mode
 * Use after creating systems in draft mode
 */
export const buildItButtonAtom = atom<
  JotaiTool<z.infer<typeof BuildItButtonParamsSchema>>
>(() => ({
  name: "build_it_button",
  description:
    "Show a Build it button in draft mode after creating systems. Transitions from draft mode to build mode by executing ZSL.",
  parameters: BuildItButtonParamsSchema,
  component: BuildItButton,
  execute: atom(null, async () => {
    const result: BuildItButtonResult = {
      success: true,
      message: 'Showing "Build it" button for ZSL execution',
    };

    return {
      content: [
        {
          type: "text",
          text: result.message,
        },
      ],
    };
  }),
}));
